export default {"src":"/org/_next/static/media/card.0b818a04.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};